const ROUTES = {
  ROOT: '/',
  AUTH: {
    LOGIN: '/login',
    LOGOUT: '/login',
    REGISTER: '/cadastrar',
    RESET_PASSWORD: '/recuperar-senha',
    CHANGE_PASSWORD: '/trocar-senha',
    CONFIRM_PHONE: '/confirmar-telefone',
    CONFIRM_EMAIL: '/confirmar-email',
    CONFIRMATIONS: '/confirmacao-da-conta'
  },
  DASHBOARD: '/dashboard',
  PROFILE: '/perfil',
  ANIMAL: {
    ROOT: '/gado',
    DETAILS: '/gado/:id',
    NEW: '/gado/novo',
    toDetails: (id: string) => `/gado/${id}`
  },
  DEATHS_AND_DISEASES: '/morte-e-doencas',
  REPRODUCTION: {
    ROOT: '/reproducao',
    COVERAGE_PROCESS: {
      ROOT: '/reproducao/processo-de-cobertura',
      DETAILS: '/reproducao/processo-de-cobertura/:id',
      NEW: '/reproducao/processo-de-cobertura/novo',
      toDetails: (id: string) => `/reproducao/processo-de-cobertura/${id}`
    },
    PREGNANCY_DIAGNOSIS: '/reproducao/diagnostico-de-gestacao',
    BIRTH_REGISTRATION: '/reproducao/cadastro-de-nascimento',
    PREGNANCY_LIST: '/reproducao/lista-de-reproducao',
    PREGNANCY_LIST_DETAILS: '/reproducao/lista-de-reproducao/:id',
    toPregnancyListDetails: (id: string, idAnimal: string, idDiagGest: string) =>
      `/reproducao/lista-de-reproducao/${id}?idAnimal=${idAnimal}&idDiagGest=${idDiagGest}`
  },
  COUPLE_PLANNING: {
    ROOT: '/casal-planejado',
    DETAILS: '/casal-planejado/:id',
    NEW: '/casal-planejado/novo',
    toDetails: (id: string) => `/casal-planejado/${id}`
  },
  GENETICS: {
    GENOTYPING: '/genotipagem',
    EVALUATION: '/avaliacao-genetica'
  },
  HERD_MANAGEMENT: {
    ROOT: '/manejo-de-rebanho',
    WEIGHTING: '/manejo-de-rebanho/pesagem',
    MOVIMENTATION: '/manejo-de-rebanho/movimentacao',
    HEALTH_CONTROL: '/manejo-de-rebanho/controle-sanitario'
  },
  HOLE_PROCESS: '/processo-mangueiro',
  LOCATIONS: {
    ROOT: '/locais',
    DETAILS: '/locais/:id',
    NEW: '/locais/novo',
    toDetails: (id: string) => `/locais/${id}`
  },
  BIRTH_FORM: {
    ROOT: '/ficha-de-nascimento'
  },
  ADMIN: {
    // RECORD_VALIDATION: '/validacao-registros',
    SALES: '/vendas',
    USERS: '/usuarios',
    PROPERTIES: '/propriedades',
    LOTS: '/lotes',
    VACCINE: '/vacinas',
    REPORTS: '/relatorios',
    ANCP: '/ancp',
    SETTINGS: '/configuracoes'
  }
}

export default ROUTES
